import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { BodySmall } from '../../text/Typography';

interface INestedCheckboxLabelProps {
    subOption?: boolean;
    label: string;
    description?: string;
}

export default function NestedCheckboxLabel({ label, description, subOption = false }: INestedCheckboxLabelProps) {
    return (
        <LabelWrapper subOption={subOption}>
            <Label>{label}</Label>
            {description && <BodySmall>{description}</BodySmall>}
        </LabelWrapper>
    );
}

const Label = styled(BodySmall)`
    color: ${(props) => props.theme.color.text};
`;

const LabelWrapper = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'subOption', // Prevent 'first' from being passed to DOM
})<{ subOption: boolean }>`
    display: grid;
    grid-template-columns: 13rem auto;
    column-gap: ${(props) => (props.subOption ? '1rem' : '3rem')};
    align-items: center;
`;
